module.exports = __webpack_public_path__ + "static/media/banner-pesquisa-usabilidade.90cbc77e.jpg";